module.exports = __webpack_public_path__ + "img/2.dc567d92.png";